<h2>{{ config.title }}</h2>
<form [formGroup]="form" (ngSubmit)="applyFilters()">

  <div *ngFor="let filter of config.filters">

    <!-- TEXT -->
    <input *ngIf="filter.type === 'text'"
           [placeholder]="filter.label"
           [formControlName]="filter.field" />

    <!-- DATE -->
    <input *ngIf="filter.type === 'date'"
           type="date"
           [formControlName]="filter.field" />

    <!-- SELECT -->
    <select *ngIf="filter.type === 'select'"
            [formControlName]="filter.field">
      <option value="">All</option>
      <option *ngFor="let opt of filter.options"
              [value]="opt.value">
        {{ opt.label }}
      </option>
    </select>

  </div>

  <button type="submit">Apply</button>
  <button (click)="exportExcel()">Export Excel</button>

</form>

<table mat-table [dataSource]="data" matSort>

  <ng-container *ngFor="let col of config.columns"
                [matColumnDef]="col.field">

    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ col.header }}
    </th>

    <td mat-cell *matCellDef="let row">
      {{ row[col.field] }}
    </td>

  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSize]="10"></mat-paginator>